import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { APP_SITE_ID } from "../../config/appSiteLinks";

/** Redirect legacy `/marketing`, `/legal`, etc. to the web app-scoped URL. */
export function AppSiteMarketingRedirect() {
    return <Navigate to={`/marketing/${APP_SITE_ID.WEB}`} replace />;
}

export function AppSiteLegalRedirect() {
    const location = useLocation();
    return <Navigate to={`/legal/${APP_SITE_ID.WEB}${location.hash || ""}`} replace />;
}

export function AppSitePrivacyRedirect() {
    return <Navigate to={`/legal/${APP_SITE_ID.WEB}#privacy`} replace />;
}

export function AppSiteTermsRedirect() {
    return <Navigate to={`/legal/${APP_SITE_ID.WEB}#terms`} replace />;
}
